import React from 'react';

/**
 * Spinner Component
 * 
 * A reusable loading spinner component for indicating background processes.
 * Can be customized with different sizes and colors.
 */
const Spinner = ({ size = 'default', color = 'primary', className = '', text = '' }) => {
  // Size mapping
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    default: 'h-8 w-8 border-4',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4'
  };

  // Color mapping (using Tailwind color classes)
  const colorClasses = {
    primary: 'border-primary-500',
    secondary: 'border-gray-500',
    success: 'border-green-500',
    danger: 'border-red-500',
    warning: 'border-yellow-500',
    info: 'border-blue-500'
  };

  // Build the class string based on size and color
  const spinnerClasses = `
    inline-block rounded-full 
    animate-spin
    border-t-transparent
    ${sizeClasses[size] || sizeClasses.default}
    ${colorClasses[color] || colorClasses.primary}
    ${className}
  `;

  return (
    <div className="flex flex-col items-center justify-center">
      <div className={spinnerClasses} role="status" aria-label="loading"></div>
      {text && <span className="mt-2 text-sm text-gray-600">{text}</span>}
    </div>
  );
};

export default Spinner;
